// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-d1cf61ac] {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n.createManually[data-v-d1cf61ac] {\n  margin-top: 5px;\n}\n.createManually p[data-v-d1cf61ac] {\n    margin: 10px 0;\n}\n> > > .creatTrip_Box .el-dialog[data-v-d1cf61ac] {\n  width: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
